import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

const LOGIN_BG = "https://static.prod-images.emergentagent.com/jobs/b367524c-0338-4ff4-9863-5e4f32f63fe6/images/6ee4a7859154bd30bd5a96025e6f43e834ecd42df2fd351fbf45cb84698078e5.png";

export default function LoginPage() {
  const { login, user } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  if (user) return <Navigate to="/" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      toast.success(`Welcome, ${u.full_name}`);
      navigate("/");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally { setLoading(false); }
  };

  const quickLogin = (em, pw) => { setEmail(em); setPassword(pw); };

  return (
    <div className="min-h-screen grid grid-cols-1 lg:grid-cols-2" data-testid="login-page">
      {/* Left: form */}
      <div className="flex flex-col justify-between p-10 lg:p-16 bg-white border-r border-border">
        <div className="flex items-center gap-3">
          <div className="w-9 h-9 bg-black flex items-center justify-center">
            <div className="w-3 h-3 bg-[#FF5000]" />
          </div>
          <div>
            <div className="font-head font-black tracking-tight text-lg leading-none">PRIDE GLOBAL</div>
            <div className="data-label mt-1">Admin Central · v1.0</div>
          </div>
        </div>

        <div className="max-w-md w-full">
          <h1 className="font-head font-black uppercase text-4xl lg:text-5xl tracking-tighter leading-[0.95]">
            Command<br/>
            <span className="text-[#FF5000]">your IT Support.</span>
          </h1>
          <p className="text-sm text-muted-foreground mt-4 leading-relaxed max-w-sm">
            Support Desk.
            Sign in to continue.
          </p>

          <form onSubmit={submit} className="mt-10 space-y-5" data-testid="login-form">
            <div>
              <Label className="data-label" htmlFor="email">Email</Label>
              <Input id="email" data-testid="login-email-input" className="mt-2 font-mono" value={email} onChange={(e) => setEmail(e.target.value)} required autoComplete="email" />
            </div>
            <div>
              <Label className="data-label" htmlFor="password">Password</Label>
              <Input id="password" data-testid="login-password-input" type="password" className="mt-2 font-mono" value={password} onChange={(e) => setPassword(e.target.value)} required autoComplete="current-password" />
            </div>
            <Button type="submit" data-testid="login-submit-btn" disabled={loading} className="w-full bg-black hover:bg-[#FF5000] hover:text-white text-white h-11 font-head uppercase tracking-wider text-sm">
              {loading ? "Signing in..." : "Sign In →"}
            </Button>
          </form>

        </div> 
        <div className="data-label">© Pride Global · Secure Enterprise Access</div>
      </div>

      {/* Right: visual */}
      <div className="hidden lg:block relative bg-black overflow-hidden">
        <img src={LOGIN_BG} alt="" className="absolute inset-0 w-full h-full object-cover opacity-90" />
        <div className="absolute inset-0 grid-bg opacity-30 mix-blend-overlay" />
        <div className="absolute bottom-10 left-10 right-10">
          <div className="glass-panel p-6">
            <div className="data-label mb-2">LIVE METRIC · 00:00 UTC</div>
            <div className="font-head font-black text-3xl tracking-tighter">IT OPERATIONS · NOMINAL</div>
            <div className="mt-3 grid grid-cols-4 gap-4">
              {[["ASSETS",""],["TICKETS",""],["SLA",""],["ALERTS",""]].map(([l,v]) => (
                <div key={l}>
                  <div className="data-label">{l}</div>
                  <div className="font-mono font-medium text-lg">{v}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
